import React from 'react';
import * as GsmCharsetUtils from '@trt2/gsm-charset-utils';

const SMSCounter = ({ message }) => {
  const smsCountObj = GsmCharsetUtils.getCharCount(message);

  return (
    <>
      <span className="sms-counter d-flex align-items-center" style={{ gap: 10 }}>
        <strong>
          Characters: {smsCountObj.charCount}/{smsCountObj.msgCount * smsCountObj.charsPerSegment}
        </strong>
        <strong
          style={{
            background: '#E2E8F0',
            borderRadius: '5px',
            padding: '2px 4px',
          }}
        >
          SMS: {smsCountObj.msgCount}
        </strong>
      </span>
    </>
  );
};

export default SMSCounter;
